import React from 'react';
import './PdfEdit.scss';
import ImagePdfIcon from '../../assets/ImagePdfIcon.png';
import TextIcon from '../../assets/TextIcon.png';
import HighlightIcon from '../../assets/HighlightIcon.png';
import WatermarkIcon from '../../assets/WatermarkIcon.png';
import EsignIcon from '../../assets/EsignIcon.png';
import EraseIcon from '../../assets/EraseIcon.png';

export default function PdfEdit() {
  return (
    <div className='edit-container'>
      <div className='left-section'>
        <div className='row1'>
          <div className='image-to-pdf-container'>
            <div className='image-icon-container'>
              <img src={ImagePdfIcon} alt="convert to pdf" />
            </div>
            <p>Add Image</p>
            <p>to PDF</p>
          </div>
          <div className='text-to-pdf-container'>
            <div className='text-icon-container'>
              <img src={TextIcon} alt="text to pdf" />
            </div>
            <p>Add Text to</p>
            <p>Pdf</p>
          </div>
          <div className='text-to-pdf-container'>
            <div className='text-icon-container'>
              <img src={EsignIcon} alt="e-sign" />
            </div>
            <p>eSign</p>
            <p>PDF</p>
          </div>
        </div>
        <div className='row2'>
          <div className='highlight-in-pdf-container'>
            <div className='highlight-icon-container'>
              <img src={HighlightIcon} alt="highlight" />
            </div>
            <p>Highlight in</p>
            <p>Pdf</p>
          </div>
          <div className='add-watermark-container'>
            <div className='watermark-icon-container'>
              <img src={WatermarkIcon} alt="add watermark" />
            </div>
            <p>Add</p>
            <p>waterMark</p>
          </div>
          <div className='add-watermark-container'>
            <div className='watermark-icon-container'>
              <img src={EraseIcon} alt="erase text in pdf" />
            </div>
            <p>Erase Text</p>
            <p>on PDF</p>
          </div>
        </div>
      </div>
      <div className='right-section'>
        <h1>Edit Your Way!</h1>
        <p>
          Take full control of your PDFs with easy-to-use tools that let you add images, insert text, highlight important details, and apply watermarks effortlessly. Enhance readability, personalize content, and make your documents more professional—all in just a few clicks!
        </p>
      </div>
    </div>
  )
}
